import { useQuery } from "react-query";
import { getAllGuarantors } from "services/guarantor.service";

export default function useGuarantors(params?: {
  page?: number;
  limit?: number;
}) {
  return useQuery(["guarantors", params], () => getAllGuarantors(params), {
    keepPreviousData: true,
  });
}
